import { trendingItems } from "@/mocks/categories";
import { trendingTitle, trendingSubtitle } from "@/mocks/content";

export default function TrendingFinds() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-12">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-2">
              {trendingTitle}
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">{trendingSubtitle}</p>
          </div>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap flex items-center gap-1"
          >
            See all finds
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {trendingItems.map((item) => (
            <div key={item.name} className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/50 hover:border-background-300/60 transition-all">
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.name} from AllChinaBuy Spreadsheet`}
                  title={`AllChinaBuy Spreadsheet ${item.name}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                {/* Price tag */}
                <span className="absolute top-3 right-3 px-3 py-1 bg-accent-100 text-accent-800 rounded-full text-xs font-semibold whitespace-nowrap">
                  {item.price}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-1">{item.name}</h3>
                <p className="text-sm text-foreground-600">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}